import { Button } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";
import { useEmailModal } from "../store/useEmailModal";

export default function OpenSendEmailButton({
  caseData,
  disabled,
  buttonText = "Send Email",
  templateName,
}) {
  const { setOpenEmailModal } = useEmailModal();

  return (
    <Button
      variant="contained"
      onClick={() => setOpenEmailModal({ caseData, modalTitle: buttonText, templateName })}
      size="small"
      disabled={disabled}
      sx={{
        padding: "10px 18px",
        borderRadius: "999px",
        textTransform: "none",
        backgroundColor: HNSColors.primary[500],
        color: HNSColors.neutrals[900],
        "&:hover": {
          backgroundColor: HNSColors.primary[600],
          borderColor: "transparent",
        },
        "&.Mui-disabled": {
          backgroundColor: HNSColors.tertiary[800],
          color: HNSColors.neutrals[900],
        },
      }}
    >
      {buttonText}
    </Button>
  );
}
